function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".abf387e8-3aef-43e7-96c5-8db008fdb562{fill:#fbbc0f;}"));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "abf387e8-3aef-43e7-96c5-8db008fdb562",
  d: "M44.92,56.92,30.2,46.16a1.43,1.43,0,0,0-1.69,0L13.73,56.83a1.44,1.44,0,0,1-2.21-1.61l5.69-17.34a1.45,1.45,0,0,0-.51-1.6L2,25.4a1.44,1.44,0,0,1,.85-2.6H21.06a1.42,1.42,0,0,0,1.36-1L28.11,4.66a1.43,1.43,0,0,1,2.73,0L36.42,22a1.45,1.45,0,0,0,1.37,1H56a1.44,1.44,0,0,1,.84,2.6L42.07,36.35a1.44,1.44,0,0,0-.52,1.6l5.59,17.37A1.44,1.44,0,0,1,44.92,56.92Z",
  transform: "translate(-1.38 -3.68)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "abf387e8-3aef-43e7-96c5-8db008fdb562",
  d: "M118.74,56.92,104,46.16a1.43,1.43,0,0,0-1.69,0L87.55,56.83a1.44,1.44,0,0,1-2.21-1.61L91,37.88a1.44,1.44,0,0,0-.52-1.6L75.79,25.4a1.44,1.44,0,0,1,.85-2.6H94.88a1.42,1.42,0,0,0,1.36-1l5.69-17.16a1.43,1.43,0,0,1,2.73,0L110.24,22a1.45,1.45,0,0,0,1.37,1h18.23a1.44,1.44,0,0,1,.84,2.6L115.89,36.35a1.44,1.44,0,0,0-.52,1.6L121,55.32A1.44,1.44,0,0,1,118.74,56.92Z",
  transform: "translate(-1.38 -3.68)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "abf387e8-3aef-43e7-96c5-8db008fdb562",
  d: "M192.56,56.92,177.84,46.16a1.43,1.43,0,0,0-1.69,0L161.37,56.83a1.44,1.44,0,0,1-2.21-1.61l5.69-17.34a1.44,1.44,0,0,0-.52-1.6L149.6,25.4a1.44,1.44,0,0,1,.86-2.6H168.7a1.42,1.42,0,0,0,1.36-1l5.69-17.16a1.43,1.43,0,0,1,2.73,0L184.06,22a1.44,1.44,0,0,0,1.37,1h18.22a1.44,1.44,0,0,1,.85,2.6L189.71,36.35a1.44,1.44,0,0,0-.52,1.6l5.59,17.37A1.44,1.44,0,0,1,192.56,56.92Z",
  transform: "translate(-1.38 -3.68)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "abf387e8-3aef-43e7-96c5-8db008fdb562",
  d: "M266.38,56.92,251.66,46.16a1.43,1.43,0,0,0-1.69,0L235.19,56.83A1.44,1.44,0,0,1,233,55.22l5.69-17.34a1.44,1.44,0,0,0-.52-1.6L223.42,25.4a1.44,1.44,0,0,1,.86-2.6h18.24a1.42,1.42,0,0,0,1.36-1l5.68-17.16a1.44,1.44,0,0,1,2.74,0L257.88,22a1.44,1.44,0,0,0,1.37,1h18.22a1.44,1.44,0,0,1,.85,2.6L263.53,36.35A1.44,1.44,0,0,0,263,38l5.59,17.37A1.44,1.44,0,0,1,266.38,56.92Z",
  transform: "translate(-1.38 -3.68)"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "abf387e8-3aef-43e7-96c5-8db008fdb562",
  d: "M340.2,56.92,325.48,46.16a1.43,1.43,0,0,0-1.69,0L309,56.83a1.44,1.44,0,0,1-2.21-1.61l5.69-17.34a1.44,1.44,0,0,0-.52-1.6L297.24,25.4a1.44,1.44,0,0,1,.86-2.6h18.24a1.42,1.42,0,0,0,1.36-1l5.68-17.16a1.44,1.44,0,0,1,2.74,0L331.7,22a1.44,1.44,0,0,0,1.37,1h18.22a1.44,1.44,0,0,1,.85,2.6L337.35,36.35a1.44,1.44,0,0,0-.52,1.6l5.58,17.37A1.43,1.43,0,0,1,340.2,56.92Z",
  transform: "translate(-1.38 -3.68)"
});

var SvgGoogle5Stars = function SvgGoogle5Stars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b45dd988-6433-46e2-8627-1a2e088b0163",
    "data-name": "Layer 1",
    viewBox: "0 0 351.36 53.52",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle5Stars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google-5-stars.05975b35.svg";
export { ForwardRef as ReactComponent };